import { render, staticRenderFns } from "./CreateCeremonyModal.vue?vue&type=template&id=5a9795ae"
import script from "./CreateCeremonyModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateCeremonyModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports